import React from 'react';
import { motion } from 'framer-motion';
export function Bonos() {
  const bonos = [{
    number: '1',
    emoji: '🏥',
    cover: '#5A8A7D',
    title: 'Bonus 1 — Guía de Supervivencia Hospitalaria',
    description: 'Qué llevar, cómo conducirte en sala, leer la HC, jerarquía hospitalaria y protocolo de guardia.',
    value: '$10.000'
  }, {
    number: '2',
    emoji: '📋',
    cover: '#6E8B6E',
    title: 'Bonus 2 — Fichas de Evaluación Kinésica',
    description: 'Modelos de examen físico por región con el formato exacto que piden los docentes argentinos.',
    value: '$9.000'
  }, {
    number: '3',
    emoji: '🗺️',
    cover: '#C08457',
    title: 'Bonus 3 — Mapa Maestro de Patrones de Dolor',
    description: 'Dolor referido, dermatomas, trigger points y algoritmo de diagnóstico diferencial.',
    value: '$10.000'
  }, {
    number: '4',
    emoji: '🩺',
    cover: '#6B7A99',
    title: 'Bonus 4 — Signos Vitales y Valores de Alarma',
    description: 'Tabla maestra, escalas de Borg y MRC, protocolos de emergencia y criterios de suspensión de sesión.',
    value: '$9.000'
  }, {
    number: '5',
    emoji: '🎓',
    cover: '#C9A24B',
    title: 'Bonus 5 — Guía Definitiva de Finales',
    description: 'Las preguntas que siempre hacen con las respuestas modelo que los docentes quieren escuchar. Simulacro de parcial incluido.',
    value: '$8.000'
  }, {
    number: '6',
    emoji: '💼',
    cover: '#8A6B8C',
    title: 'Bonus 6 — Cómo Empezar a Trabajar como Kinesiólogo',
    description: 'Matrícula, monotributo, primera consulta, historia clínica, precios y hoja de ruta para tu primer año profesional.',
    value: '$10.000'
  }];
  return <section className="w-full bg-[#F7F5F2] py-14 md:py-20 px-4" data-id="element-20">
      <div className="max-w-5xl mx-auto" data-id="element-21">
        {/* Header */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-10 md:mb-14" data-id="element-22">
          <h2 className="text-3xl md:text-5xl font-extrabold text-slate-900 mb-3 tracking-tight" data-id="element-23">
            + 6 Regalos Estratégicos
          </h2>
          <p className="text-lg md:text-xl text-slate-500 font-medium mb-6" data-id="element-24">
            Incluidos sin costo extra · Valor real del pack
          </p>
          <motion.div initial={{
          opacity: 0,
          scale: 0.9
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} className="inline-flex items-center gap-2 bg-[#C97B5A] text-white font-bold text-sm md:text-lg px-6 py-3 rounded-full shadow-md" data-id="element-25">
            🎁 GRATIS POR EL DÍA DE HOY
          </motion.div>
        </motion.div>

        {/* Bonus cards */}
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6 mb-12" data-id="element-26">
          {bonos.map((bono, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.08
        }} className="bg-white rounded-2xl shadow-sm border border-slate-100 p-6 flex flex-col items-center text-center" data-id="element-27">
              {/* Book cover mockup */}
              <div className="relative w-36 h-48 rounded-r-lg rounded-l-sm shadow-xl mb-5 flex flex-col justify-between p-4 text-left" style={{
            backgroundColor: bono.cover
          }} data-id="element-28">
                <span className="absolute left-0 top-0 bottom-0 w-2 rounded-l-sm" style={{
              backgroundColor: 'rgba(0,0,0,0.18)'
            }} aria-hidden="true" data-id="element-29" />
                <div className="text-2xl" data-id="element-30">{bono.emoji}</div>
                <div data-id="element-31">
                  <div className="text-white font-bold text-lg leading-tight" data-id="element-32">
                    Bonus {bono.number}
                  </div>
                  <div className="border-t border-white/30 mt-3 pt-2" data-id="element-33">
                    <span className="text-white/80 text-[10px] font-semibold tracking-wider uppercase" data-id="element-34">
                      Rescate Académico™
                    </span>
                  </div>
                </div>
              </div>

              {/* GRATIS pill */}
              <span className="inline-block bg-[#E3F2EC] text-[#2F6B57] font-bold text-xs px-4 py-1 rounded-full mb-3" data-id="element-35">
                GRATIS
              </span>

              {/* Title */}
              <h3 className="font-bold text-slate-900 text-lg mb-2 leading-snug" data-id="element-36">
                {bono.emoji} {bono.title}
              </h3>

              {/* Description */}
              <p className="text-slate-500 text-sm leading-relaxed mb-3" data-id="element-37">
                {bono.description}
              </p>

              <p className="text-slate-400 text-sm font-medium mt-auto" data-id="element-38">
                Valor: {bono.value} →{' '}
                <span className="text-[#2F6B57] font-bold" data-id="element-39">GRATIS</span>
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}